import NotificationUtil from "../_notificationUtil";
import Interfaces from "../_interfaces";

export function HandleDXCallbackError(gridName: string) {
    let grid: Interfaces.MVCxClientGridViewWithCallbackErrorMessage = window[gridName] as Interfaces.MVCxClientGridViewWithCallbackErrorMessage;
    let errorMessage: string = grid.cpCallbackErrorString;

    if (errorMessage) {
        NotificationUtil.Error(errorMessage);
    }  
}
